export default function Stores() {
  return (
    <div className="section-header">
      <h2>Stores Management</h2>
      <p>Manage store details and operations</p>
      <p>Store data will be displayed here.</p>
    </div>
  );
}